


import { Typography, Grid, Card, CardContent, CardHeader, CardMedia, CardActionArea } from '@mui/material'
import { connect } from 'react-redux'
import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';

import { Sheet, MiniGroup } from '../../redux/entities'
import { getSheets } from '../../redux/store'
import { Plus } from 'lucide-react';

import { makeStyles } from '@mui/styles';
import { unwrapResult } from '@reduxjs/toolkit';
import PackedSheetView from "./PackedSheetView";
import { DEFAULT_PAPER } from "./paperSizes";


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    box: {

    }
}));


const Item = styled(Card)(({ theme }) => ({
    // Light mode only for now (dark mode deferred) — always use the warm card surface.
    backgroundColor: theme.palette.background.paper,
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    minHeight: 140,
    transition: 'transform 150ms ease, box-shadow 150ms ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows[3],
    },
}));


function SheetCard(props) {
    // console.log("cardprops", props)
    const {sheet, onSelect} = props;
    return (
        <Grid item xs={12} sm={4} md={3} >
            <Item sx={{ height: "100%"}}
                elevation={1}
                key={sheet.id}
                >
                <CardActionArea onClick={e => { if (onSelect) onSelect(sheet) }}>
                    <CardHeader title={sheet.name}>
                    </CardHeader>
                    <CardMedia>
                        <PackedSheetView sheet={sheet} />
                    </CardMedia>
                </CardActionArea>

            </Item >
        </Grid>
    );
}

function PlusOneCard({ onClick }) {
    return (
        <Grid item xs={12} sm={6} md={3} sx={{}}>
            <Item sx={{ backgroundColor: (theme) => theme.palette.primary.light , height: "100%"}}
                elevation={1}
                onClick={e => { if (onClick) onClick() }}>
                <CardHeader title={"New sheet"} />
                <CardContent>
                    <Plus size={20} strokeWidth={2} />
                </CardContent>
            </Item >
        </Grid>
    );
}


function SheetGrid(props) {
    const classes = useStyles();

    const { sheets, create, fetchAll, onSelect, fetchAllMinis } = props;

    useEffect(() => {
        // ensure relevant state is loaded from backend on mount
        fetchAll();
        fetchAllMinis();
    }, [])

    if (!sheets) return <p>Loading...</p>

    function onCreate(e) {
        create({ name: "New sheet", papersize: DEFAULT_PAPER })
            .then(response => unwrapResult(response)).then(blank => { if (onSelect) onSelect(blank) })
    }

    let items = sheets.map(s => <SheetCard key={"sheet-"+s.id} sheet={s} onSelect={onSelect}/>);
    items.unshift(<PlusOneCard onClick={onCreate} key={"plusonecard"} />); // add first


    return (
        <div className={classes.box}  >
            <Typography variant='h4' align='left' spacing={2}>Your sheets</Typography>
            <Grid container
                spacing={1}
                columns={{ xs: 4, sm: 8, md: 12 }}
                justifyContent="center"
                direction="row"
                gridAutoFlow="column"
            >
                {items}
            </Grid>
        </div >
    );

}

function mapStateToProps(state) {
    const sheets = getSheets(state);
    // console.log("Sheets loaded", sheets)
    return { sheets: sheets || [] };
};



export default connect(mapStateToProps, {
    update: Sheet.actions.updateEntityAsync,
    create: Sheet.actions.createEntityAsync,
    remove: Sheet.actions.removeEntityAsync,
    fetchAll: Sheet.actions.fetchAllEntities,
    fetchAllMinis: MiniGroup.actions.fetchAllEntities,
})(SheetGrid)

